import React from 'react';
import { GQL } from '@gin-betting/core';
import cn from 'classnames';
import cd from 'debug';

import UserDevice from 'services/user-device';
import RestrictionsComboSystem from '../RestrictionsComboSystem';
import ExpressPartDesk, { ExpressPartMob } from './ExpressPart';
import SinglePartDesk, { SinglePartMob } from './SinglePart';
import SystemPartDesk, { SystemPartMob } from './SystemPart';

import './betslipFooter.scss';

const debug = cd('app:betslip:components:BetslipFooter');

const isMobile = UserDevice.getInstance()?.isDeviceMobile();

const SinglePart = isMobile ? SinglePartMob : SinglePartDesk;
const ExpressPart = isMobile ? ExpressPartMob : ExpressPartDesk;
const SystemPart = isMobile ? SystemPartMob : SystemPartDesk;

interface Props {
    betslipBetId: string;
    mode: GQL.BetType;
    isDisabled: boolean;
}

const BetslipFooter: React.FC<Props> = props => {
    debug('render', props);

    const { mode, betslipBetId, isDisabled } = props;

    return (
        <div styleName="container" className="__app-BetslipFooter-container">
            <div
                className={cn('__app-BetslipFooter-footer', {
                    '__app-BetslipFooter-is-disabled': isDisabled,
                })}
                styleName={cn('footer', {
                    'is-disabled': isDisabled,
                })}
            >
                {mode === GQL.BetType.SINGLE && (
                    <SinglePart betslipBetId={betslipBetId} />
                )}

                {mode === GQL.BetType.EXPRESS && (
                    <React.Fragment>
                        <ExpressPart betslipBetId={betslipBetId} />
                        <RestrictionsComboSystem betslipBetId={betslipBetId} />
                    </React.Fragment>
                )}

                {mode === GQL.BetType.SYSTEM && (
                    <React.Fragment>
                        <SystemPart betslipBetId={betslipBetId} />
                        <RestrictionsComboSystem betslipBetId={betslipBetId} />
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default BetslipFooter;
